/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useIntl } from "react-intl";
import { useTheme } from "../../../../config/emotion";
import EwaButton2 from "./EwaButton/EwaButton2";
import { labellessButtonCss } from "./styles";
import { PurposedButtonProps } from "./types";

const UserMappingButton = (props: PurposedButtonProps) => {
  const { formatMessage } = useIntl();
  const { colors } = useTheme();
  return (
    <EwaButton2
      buttonColor={colors.secondaryColor}
      iconName="shuffle"
      tooltip={formatMessage({ id: "users.show_mapping" })}
      css={labellessButtonCss}
      {...props}
      dataCy="user-mapping-button"
    />
  );
};

export default UserMappingButton;
